var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.4,
    height: 21.837,
    viewBox: "0 0 19.4 21.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL0_wght300_GRAD0_opsz24",
    d: "M183.632-793.546a2.252,2.252,0,0,1-1.653-.685,2.252,2.252,0,0,1-.685-1.653V-812.3H180v-1.94h5.82v-1.144h7.76v1.144h5.82v1.94h-1.293v16.415a2.257,2.257,0,0,1-.679,1.659,2.257,2.257,0,0,1-1.659.679ZM196.168-812.3H183.234v16.415a.387.387,0,0,0,.112.286.387.387,0,0,0,.286.112H195.77a.38.38,0,0,0,.274-.124.381.381,0,0,0,.124-.274V-812.3Zm-9.824,14.227h1.94v-11.64h-1.94Zm4.775,0h1.94v-11.64h-1.94ZM183.234-812.3v0Z",
    transform: "translate(-180.001 815.383)",
    fill: "#dfdfdf"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.9a6e1d8adb6e798869d3a5450bda5174.svg";
export { ForwardRef as ReactComponent };